module.exports = __webpack_public_path__ + "img/bg_search_noData.8a8999a6.png";